import React from "react";
import { TbDatabaseOff } from "react-icons/tb";
import { Table, LoadingOverlay, ScrollArea } from "@mantine/core";

const CustomTable = ({
  rows,
  columns,
  isLoading,
  isError,
  isSensorLogs = false,
}: {
  rows: any;
  columns: any;
  isLoading: boolean;
  isError: boolean;
  isSensorLogs?: boolean;
}) => {
  return (
    <>
      <LoadingOverlay
        visible={isLoading}
        zIndex={900}
        overlayProps={{ radius: "10px", blur: 2 }}
      />
      <ScrollArea.Autosize mah={isSensorLogs ? 500 : "100%"}>
        <Table
          verticalSpacing="md"
          borderColor="#D5DAE1"
          withColumnBorders
          withRowBorders
        >
          <Table.Thead>
            <Table.Tr>{columns}</Table.Tr>
          </Table.Thead>
          <Table.Tbody>{rows}</Table.Tbody>
        </Table>
        {isError && (
          <div className="  flex items-center h-[200px] justify-center ">
            Error fetching data
          </div>
        )}
        {rows.length === 0 && !isError && (
          <div className="flex   items-center h-[200px] justify-center ">
            <div className="flex flex-col gap-4 text-grayText2 items-center">
              <TbDatabaseOff className="text-4xl" />
              <span className="text-xl">No data available </span>
            </div>
          </div>
        )}
      </ScrollArea.Autosize>
    </>
  );
};

export default CustomTable;
